"use strict";export default function n(e){return e.toLowerCase()}
//# sourceMappingURL=toLowercaseEnumValue.js.map
